<template>
  <el-container class="content" style="display: block;">

	<el-container class="lables">
		<el-row  class="la-list">
			<el-col :span="10" class="first">
				<el-row>
					<div class="search">
						<input type="text" v-model="searchF" @change="loadData()"/>
					</div>
				</el-row>
				<el-row class="lable-o-l lable-o-ls" v-for="(item,index) in lableFirst" :key="index">
					<div class="title-n" v-for="(items,indexs) in item" :key="indexs" v-if="items['zhu'] == 1">{{items['name']}}</div>
          <el-row>
          	<el-col :span="12">
              <el-dropdown>
                <el-button type="primary" style="background-color: #409eff;">
                  指令<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(items,indexs) in item" :key="indexs" v-if="items['type'] > 1" @click.native="chose(item[0]['name'],items.name,items.id)" >{{items['name']}}</el-dropdown-item>

                </el-dropdown-menu>
              </el-dropdown>
            </el-col>
            <el-col :span="12">
              <el-dropdown>
                <el-button type="primary" style="background-color: #409eff;">
                  回应<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(items,indexs) in item" :key="indexs" v-if="items['z_h'] == 2" @click.native="chose(item[0]['name'],items.name,items.id)">{{items['name']}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-col>
          </el-row>
				</el-row>
			</el-col>
			<el-col :span="4" class="centr"><img  src="../../assets/image/next.jpg"/></el-col>
			<el-col :span="10" class="two">
				<el-row>
          <div class="title-n" style="margin-bottom: 20px;">{{titleOne}}</div>
          <div class="title-n" style="margin-bottom: 20px;font-size: 20px;">{{titleTwo}}</div>
					<div class="search">
						<input type="text"  v-model="searchT" @change="loadDataTwo()"/>
					</div>
					<div class="add" @click="add(2)" v-if="this.$store.getters.getRole == 'admins' || this.$store.getters.getRole == 'fenxi' || this.$store.getters.getRole == 'admin' || this.$store.getters.getRole == 'entry'">+ 添加</div>
				</el-row>
				<el-row class="lable-o-l">
					<div class="lable-two" v-for="(item,index) in lableTwo" :class="{'choses':choseAT.indexOf(item.id)>-1}" :key="index" @click="lableC(item.id,item.name)">{{item.name}}</div>

				</el-row>
			</el-col>
		</el-row>

	</el-container>
	 <el-dialog
	  title="添加"
	  :visible.sync="centerDialogVisible"
	  width="30%"
	  center>
	  <input type="text" v-focus="picFocusStatus" class="searchT" v-model="addT"/>
	  <span slot="footer" class="dialog-footer">
		<el-button @click="centerDialogVisible = false">取 消</el-button>
		<el-button type="primary" @click="doAdd()">确 定</el-button>
	  </span>
	</el-dialog>
	<el-dialog
	  title="提示"
	  :visible.sync="dialogVisible"
	  width="30%"
	  :before-close="handleClose">
	  <span>指令与<{{acp}}>重复!是否继续添加?</span>
	  <span slot="footer" class="dialog-footer">
		<el-button @click="dialogVisible = false">取 消</el-button>
		<el-button type="primary" @click="doAdds()">确 定</el-button>
	  </span>
	</el-dialog>
  </el-container>
</template>

<script>

  export default {
    data() {
      return {
        lableFirst:[],
		lableTwo:[],
		chosesT:0,
		choses:0,
		choseAF:[],
		choseAT:[],
		searchF:'',
		searchT:'',
		lable:[],
		lableEx:'',
		centerDialogVisible:false,
		addType:0,
		picFocusStatus:false,
		addT:'',
		dialogVisible: false,
		acp:'',
		addcf:0,
    titleOne:'',
    titleTwo:'',
		token:window.localStorage.getItem('token'),
		userId:window.localStorage.getItem('id'),
		url:this.$store.getters.getUrl
      };
    },
	directives: {
		focus: {
		  inserted: function(el, { value }) {
			if (value) {
			  el.focus();
			}
		  }
		}
    },
    created() {
		//var cip = returnCitySN["cip"];
// 		if(this.$store.getters.getRole != 'admins'){
// 				   if(cip !='117.9.19.251' && cip !='60.27.105.250' && cip !='60.27.106.235'){
// 					   this.$router.push({ path: '/' })
// 				   }
// 		}
    if(!window.localStorage.getItem('id')){
      this.$router.push({ path: '/' })
    }
       this.loadData();
	   var lett = this;
	   document.onkeydown = function(e) {
	   	var key = window.event.keyCode;
	   	if (key == 13) {
	   		lett.doAdd();
	   	}
		if (key == 17) {
			if(lett.choses > 0){
				lett.add(2);
			}

		}
	   }

    },

	methods:{
		loadData(){
			const axiosInstance = this.$axios.create({
				headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
				withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
			});
			axiosInstance({
				method:'get',
				params:{
					name:this.searchF
				},
				url:'http://fencip.yoooooo.com/index.php/index/data/acFirstbaon'
			})
			.then(res=>{
				this.lableFirst = res.data;

			})
			.catch(err=>{

			});
		},
		loadDataTwo(){
			const axiosInstance = this.$axios.create({
				headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
				withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
			});
			axiosInstance({
				method:'get',
				params:{
					name:this.searchT,
					p_id:this.choses
				},
				url:'http://fencip.yoooooo.com/index.php/index/data/acTwobn'
			})
			.then(res=>{
				this.lableTwo = res.data;

			})
			.catch(err=>{

			});
		},
		chose(name,name1,id){
      this.titleOne = name
      this.titleTwo = name1
			this.choses = id;
			this.searchT = '';
			this.loadDataTwo();

		},
		lableC(id,name){
      if (this.$store.getters.getRole == 'admins' || this.$store.getters.getRole == 'fenxi' || this.$store.getters.getRole == 'admin'){
        this.addT = name;
        this.chosesT = id;
        this.add(1);
      }

		},

		add(type){
			this.addType = type;
			if(type == 2){

				this.addT = '';
			}
			this.centerDialogVisible = true;
			this.picFocusStatus = true

		},
		msg(msg,type){
			this.$message({
			  message: msg,
			  type: type
			});
		},
		doAdds(){
			let p_id = this.choses;
			const axiosInstance = this.$axios.create({
				headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
				withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
			});
			axiosInstance({
				method:'post',
				params:{
					addcf:1,
					name:this.addT,
					p_id:p_id,
					token:this.token,
					userId:this.userId
				},
				url:'http://fencip.yoooooo.com/index.php/index/data/acAddbn'
			})
			.then(res=>{
				if(res.data.code == 200){
					this.centerDialogVisible = false;
					this.addT = '';
					this.dialogVisible = false
					this.acp = ''
					if(this.addType == 1){
						this.loadData();
					}else{
						this.loadDataTwo();
					}
					this.addType = 0
				}else{
					this.centerDialogVisible = false;
					this.addT = '';
					alert('添加失败')
				}

			})
			.catch(err=>{

			});
		},
		doAdd(){
			if(this.addT == ''){
				this.msg('内容不能为空','error')
				return false;
			}
			if(this.addType == 2){
				let p_id = this.choses;
				const axiosInstance = this.$axios.create({
					headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
					withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
				});
				axiosInstance({
					method:'post',
					params:{
						addcf:0,
						name:this.addT,
						p_id:p_id,
						token:this.token,
						userId:this.userId
					},
					url:'http://fencip.yoooooo.com/index.php/index/data/acAddbn'
				})
				.then(res=>{
					if(res.data.code == 200){
						this.centerDialogVisible = false;
						this.addT = '';
						if(this.addType == 1){
							this.loadData();
						}else{
							this.loadDataTwo();
						}
						this.addType = 0
					}else if(res.data.code == 202){
						this.centerDialogVisible = false;
						this.dialogVisible = true
						this.acp = res.data.data
					}else{
						this.centerDialogVisible = false;
						this.addT = '';
						alert('添加失败')
					}

				})
				.catch(err=>{

				});
			}else{
				const axiosInstance = this.$axios.create({
					headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
					withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
				});
				axiosInstance({
					method:'post',
					params:{
						name:this.addT,
						id:this.chosesT,
						token:this.token,
						userId:this.userId
					},
					url:'http://fencip.yoooooo.com/index.php/index/data/acChangebn'
				})
				.then(res=>{
					if(res.data.code == 200){
						this.centerDialogVisible = false;
						this.loadDataTwo();
					}else{
						this.centerDialogVisible = false;
						this.addT = '';
						alert('添加失败')
					}

				})
				.catch(err=>{

				});
			}

		}
	}


  }
</script>

<style>
  .title-n{
    text-align: center;
    font-size: 28px;
    margin-right: 50px;
  }
	.content{
		background: #939AA0;
		width: 100%;
		height: 100%;
	}
	.centr{
		margin-top: 30%;
	}
	.centr img{
		width: 100px;
		height: 50px;
		margin-left: 35px;
	}

	.zhuyi{
		color: red;
	}
	.butn{
		color: #F0F8FF;
		background: #FF9400;
		margin-right: 20px;
		border-radius: 5px;
		width: 50px;
	}
	.lables{
		margin-left: 5%;
		margin-right: 5%;
		background: #fff;
		padding-bottom: 35px;
	}
	.lables .la-list{
		margin-top: 50px;
		width: 100%;
		margin-left: 20%;
		margin-right: 20%;
	}
	.first{
		border: 1px solid #c6c6c6;
		height: 850px;
		overflow-y:scroll;
	}
	.first .el-row{
		margin: 20px 10% 20px 10%;
	}
	.search input{
		width: 95%;
		height: 20px;
		margin-bottom: 10px;
		margin-left: 2%;
	}
	.add{
		text-align: center;
		width: 96%;
		background: #c6c6c6;
		height: 22px;
		line-height: 22px;
		margin-left: 2%;
	}

	.lable-o{
		width: 47%;
		text-align: center;
		background: #c6c6c6;
		height: 30px;
		line-height: 30px;
		margin-bottom: 10px;
	}
	.lable-two{

		text-align: center;
		background: #c6c6c6;

		line-height: 30px;
		margin-bottom: 10px;
	}
	.choses{
		background: #f8f1da;
	}
	.chosess{
		background: #ff9400;
	}
	.right{
		float: right;
	}
	.left{
		float: left;
	}
	.two{
		border: 1px solid #c6c6c6;
		height: 850px;
		overflow-y:scroll;
	}
	.two .el-row{
		margin: 20px 10% 20px 10%;
	}
	.searchT{
		width: 80%;
		margin-left: 10%;
		height: 30px;
	}
	.lable-o-ls{
		border-bottom: 1px solid #c6c6c6;
	}
</style>



// WEBPACK FOOTER //
// src/components/main/nAcbao.vue